export default "/images/tutorial_a.webp"